<template>
  <div v-if="value && loaded">
    <div class="activeCover"></div>
    <OpaModal width="960" height="540" v-model="value" header="Selecione a Categoria">
      <div style="height:380px;overflow:auto; padding:20px;">
        <input type="text" v-model="searchTerm" class="inputText inputSearch" placeholder="Nome"
               style="float:left;height:30px"/>
        <div @click="searchTerm=null" style="float:left;margin-top:5px;cursor:pointer;">
          <OpaIcon name="broom" style="margin-left:5px;cursor:pointer"/>
        </div>
        <br/><br/>
        <table border="1" cellpadding="5" style="width:100%;border: 1px solid #ffffff;border-collapse:collapse;">
          <tr>
            <td>Selecione</td>
            <td>Nome</td>
          </tr>
          <tr v-for="(category, idx) in filteredCategories" v-bind:key="idx">
            <td style="text-align:center;">
              <template v-if="single">
                <input type="radio" style="width:30px;height:30px;" name="categoryRadio" :value="category.id"
                       v-model="selectedCategory"/>
              </template>
              <template v-else>
                <input type="checkbox" style="width:30px;height:30px;" name="categoryBox" v-model="category.selected"/>
              </template>
            </td>
            <td>
              {{category.name}}
            </td>
          </tr>
        </table>
      </div>
      <div class="modal_footer">
        <button class="buttonFlat" style="width:180px;float:right;margin:20px;margin-right:20px;"
                @click="$emit('selectCategory', selectedCategories()); clear(); $emit('close')">Selecionar
        </button>
        <button class="buttonWire" style="width:180px;float:right;margin:20px;margin-right:0px;"
                @click="clear(); $emit('close')">Cancelar
        </button>
      </div>
    </OpaModal>
  </div>
</template>

<script>
  import axios from 'axios'
  import OpaModal from '@/components/OpaModal'
  import OpaIcon from '@/components/OpaIcon'
  import {EventBus} from '@/utils/event-bus'
  import {mapGetters} from 'vuex'
  import _ from 'lodash'

  export default {
    props: {
      single: Boolean,
      value: Boolean,
      previousSelectedIds: Array
    },
    data() {
      return {
        categories: [],
        modalCategory: this.value,
        selectedCategory: null,
        loaded: false,
        searchTerm: null
      }
    },

    watch: {
      value: function (a) {
        if (a) {
          // TODO improve this
          if (this.previousSelectedIds && this.previousSelectedIds.length && this.loaded) {
            this.categories.forEach((p) => {
              let f = this.previousSelectedIds.filter(pid => pid === p.id)
              if (f.length) {
                p.selected = true
                this.selectedCategory = p.id
              }
            })
          } else {
            this.categories.forEach((p) => {
              p.selected = false
            })
            this.selectedCategory = null
          }
        }
      }
    },

    components: {OpaModal, OpaIcon},

    async created() {

      this.modalCategory = this.value
      EventBus.$emit('showLoading', true)
      this.getAllCategories()
      EventBus.$emit('showLoading', false)
      this.loaded = true
    },

    computed: {
      ...mapGetters(['getProductApi']),

      filteredCategories() {
        if (!this.searchTerm) {
          return this.categories
        } else {
          return _.union(
            this.categories.filter(p => p.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(this.searchTerm.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) > -1),
          )
        }
      }
    },

    methods: {
      ...mapGetters(['getAdmin', 'getCompany']),

      clear() {
        this.categories.forEach(p => {
          p.selected = false
        })
      },
      selectedCategories() {
        if (!this.single) {
          return this.categories.filter(p => p.selected)
        } else {
          return this.selectedCategory
        }
      },
      getAllCategories() {
        let vm = this
        axios.get(this.getProductApi + '/categories?unfiltered=true&company_id=' + this.getCompany().companyId)
          .then((r) => {
            vm.categories = r.data.filter((c) => {
              return !c.parent_id
            }).sort((a, b) => a.order - b.order)
          })
          .catch((e) => {
            console.log(e)
          })
      }
    },
  }
</script>

<style lang="scss">
  .activeCover {
    height: auto;
    min-height: 100vh;
    width: 100vw;
    opacity: 0.49;
    background-color: #2A2531;
    position: fixed;
    top: 0px;
    left: 0px;
    z-index: 2900;
  }
</style>
